import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { sessionAPI } from '../../services/api';
import toast from 'react-hot-toast';

export const fetchSessions = createAsyncThunk('sessions/fetchSessions', async (params, { rejectWithValue }) => {
  try {
    const response = await sessionAPI.getSessions(params);
    return response.data.sessions;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch sessions');
  }
});

export const createSession = createAsyncThunk('sessions/createSession', async (sessionData, { rejectWithValue }) => {
  try {
    const response = await sessionAPI.createSession(sessionData);
    // Toast message handled by component with proper translations
    return response.data.session;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create session';
    toast.error(message);
    return rejectWithValue(message);
  }
});

export const updateSession = createAsyncThunk('sessions/updateSession', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await sessionAPI.updateSession(id, data);
    // Toast message handled by component with proper translations
    return response.data.session;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update session';
    toast.error(message);
    return rejectWithValue(message);
  }
});

const sessionSlice = createSlice({
  name: 'sessions',
  initialState: {
    items: [],
    loading: false,
    error: null,
    selectedSession: null,
  },
  reducers: {
    clearError: (state) => { state.error = null; },
    setSelectedSession: (state, action) => { state.selectedSession = action.payload; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSessions.pending, (state) => { state.loading = true; })
      .addCase(fetchSessions.fulfilled, (state, action) => { state.loading = false; state.items = action.payload; })
      .addCase(fetchSessions.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createSession.fulfilled, (state, action) => { state.items.unshift(action.payload); })
      .addCase(updateSession.fulfilled, (state, action) => {
        const index = state.items.findIndex(item => item.id === action.payload.id);
        if (index !== -1) state.items[index] = action.payload;
      });
  },
});

export const { clearError, setSelectedSession } = sessionSlice.actions;
export const selectSessions = (state) => state.sessions.items;
export const selectSessionsLoading = (state) => state.sessions.loading;
export const selectSelectedSession = (state) => state.sessions.selectedSession;
export default sessionSlice.reducer;
